import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { useUsers } from "@/contexts/users-provider";
import { TeamUserRolesEnum } from "@/enums/team-user-role";
import { useTranslation } from "@/hooks/useTranslation";
import { UserHistoryDTO } from "@shaarp/common";
import { useEffect } from "react";
import ShaarpLogo from "./../../assets/shaarp-logo.svg";

export default function DataTableCellUsersHistoryAvatar({
  userHistory,
}: {
  userHistory: UserHistoryDTO;
}) {
  const { users, apiFetchUsers } = useUsers();
  const { t } = useTranslation();

  useEffect(() => {
    const init = async () => {
      await apiFetchUsers();
    };
    init();
  }, []);

  if (!userHistory.user) {
    return t("components.dataTableUsersHistory.user.unknown");
  }

  const userIsCurrentOnTheTeam =
    userHistory.user?.id && users.find((u) => u.id === userHistory.user?.id);

  if (
    !userIsCurrentOnTheTeam &&
    userHistory.user.role === TeamUserRolesEnum.ADMIN
  ) {
    return (
      <div className="flex items-center">
        <Avatar className="w-9 h-9">
          <AvatarImage src={ShaarpLogo} alt={"Shaarp"} />
        </Avatar>
        <span className="ml-2">
          {t("components.dataTableUsersHistory.user.administrator")}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <Avatar className="w-9 h-9">
        <AvatarImage
          src={userHistory.user.imageUrl}
          alt={userHistory.user.fullName}
        />
      </Avatar>
      <span className="ml-2">
        {userHistory.user.fullName}
        {!userIsCurrentOnTheTeam && (
          <span className="ml-2">
            {t("components.dataTableUsersHistory.user.formerUser")}
          </span>
        )}
      </span>
    </div>
  );
}
